import { render } from "./ViewStudent.vue?vue&type=template&id=6a4f392e&scoped=true"
import script from "./ViewStudent.vue?vue&type=script&lang=js"
export * from "./ViewStudent.vue?vue&type=script&lang=js"

import "./ViewStudent.vue?vue&type=style&index=0&id=6a4f392e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4f392e"]])

export default __exports__